export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/',
    /* internal name: '/(product)' */
    /* no component */
    children: [
      {
        path: 'cart',
        name: '/(product)/cart',
        component: () => import('/app/src/pages/(product)/cart.vue'),
        /* no children */
      },
      {
        path: 'checkout',
        name: '/(product)/checkout',
        component: () => import('/app/src/pages/(product)/checkout.vue'),
        /* no children */
      },
      {
        path: 'product',
        /* internal name: '/(product)/product' */
        /* no component */
        children: [
          {
            path: ':slug',
            name: '/(product)/product/[slug]',
            component: () => import('/app/src/pages/(product)/product/[slug].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'product-category',
        /* internal name: '/(product)/product-category' */
        /* no component */
        children: [
          {
            path: ':slug',
            name: '/(product)/product-category/[slug]',
            component: () => import('/app/src/pages/(product)/product-category/[slug].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'shop',
        name: '/(product)/shop',
        component: () => import('/app/src/pages/(product)/shop.vue'),
        /* no children */
      },
      {
        path: 'track-order',
        name: '/(product)/track-order',
        component: () => import('/app/src/pages/(product)/track-order.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/',
    /* internal name: '/(static)' */
    /* no component */
    children: [
      {
        path: 'about-us',
        name: '/(static)/about-us',
        component: () => import('/app/src/pages/(static)/about-us.vue'),
        /* no children */
      },
      {
        path: 'contact-us',
        name: '/(static)/contact-us',
        component: () => import('/app/src/pages/(static)/contact-us.vue'),
        /* no children */
      },
      {
        path: 'faqs',
        name: '/(static)/faqs',
        component: () => import('/app/src/pages/(static)/faqs.vue'),
        /* no children */
      },
      {
        path: 'home',
        name: '/(static)/home',
        component: () => import('/app/src/pages/(static)/home.vue'),
        /* no children */
      },
      {
        path: 'privacy-policy',
        name: '/(static)/privacy-policy',
        component: () => import('/app/src/pages/(static)/privacy-policy.vue'),
        /* no children */
      },
      {
        path: 'terms-and-conditions',
        name: '/(static)/terms-and-conditions',
        component: () => import('/app/src/pages/(static)/terms-and-conditions.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/',
    /* internal name: '/(blog)' */
    /* no component */
    children: [
      {
        path: 'blog',
        /* internal name: '/(blog)/blog' */
        /* no component */
        children: [
          {
            path: '',
            name: '/(blog)/blog/',
            component: () => import('/app/src/pages/(blog)/blog/index.vue'),
            /* no children */
          },
          {
            path: ':slug',
            name: '/(blog)/blog/[slug]',
            component: () => import('/app/src/pages/(blog)/blog/[slug].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'category',
        /* internal name: '/(blog)/category' */
        /* no component */
        children: [
          {
            path: 'blog',
            /* internal name: '/(blog)/category/blog' */
            /* no component */
            children: [
              {
                path: '',
                name: '/(blog)/category/blog/',
                component: () => import('/app/src/pages/(blog)/category/blog/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'tag',
        /* internal name: '/(blog)/tag' */
        /* no component */
        children: [
          {
            path: ':slug',
            name: '/(blog)/tag/[slug]',
            component: () => import('/app/src/pages/(blog)/tag/[slug].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/',
    /* internal name: '/(order)' */
    /* no component */
    children: [
      {
        path: 'order',
        /* internal name: '/(order)/order' */
        /* no component */
        children: [
          {
            path: 'landing',
            name: '/(order)/order/landing',
            component: () => import('/app/src/pages/(order)/order/landing.vue'),
            /* no children */
          },
          {
            path: 'payment',
            /* internal name: '/(order)/order/payment' */
            /* no component */
            children: [
              {
                path: 'fail',
                name: '/(order)/order/payment/fail',
                component: () => import('/app/src/pages/(order)/order/payment/fail.vue'),
                /* no children */
              },
              {
                path: 'success',
                name: '/(order)/order/payment/success',
                component: () => import('/app/src/pages/(order)/order/payment/success.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/',
    /* internal name: '/(user)' */
    /* no component */
    children: [
      {
        path: 'my-account',
        /* internal name: '/(user)/my-account' */
        /* no component */
        children: [
          {
            path: '',
            name: '/(user)/my-account/',
            component: () => import('/app/src/pages/(user)/my-account/index.vue'),
            /* no children */
          },
          {
            path: 'customer-logout',
            name: '/(user)/my-account/customer-logout',
            component: () => import('/app/src/pages/(user)/my-account/customer-logout.vue'),
            /* no children */
          },
          {
            path: 'edit-account',
            name: '/(user)/my-account/edit-account',
            component: () => import('/app/src/pages/(user)/my-account/edit-account.vue'),
            /* no children */
          },
          {
            path: 'edit-address',
            /* internal name: '/(user)/my-account/edit-address' */
            /* no component */
            children: [
              {
                path: '',
                name: '/(user)/my-account/edit-address/',
                component: () => import('/app/src/pages/(user)/my-account/edit-address/index.vue'),
                /* no children */
              },
              {
                path: 'billing',
                name: '/(user)/my-account/edit-address/billing',
                component: () => import('/app/src/pages/(user)/my-account/edit-address/billing.vue'),
                /* no children */
              },
              {
                path: 'shipping',
                name: '/(user)/my-account/edit-address/shipping',
                component: () => import('/app/src/pages/(user)/my-account/edit-address/shipping.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'line-binding',
            name: '/(user)/my-account/line-binding',
            component: () => import('/app/src/pages/(user)/my-account/line-binding.vue'),
            /* no children */
          },
          {
            path: 'login',
            name: '/(user)/my-account/login',
            component: () => import('/app/src/pages/(user)/my-account/login.vue'),
            /* no children */
          },
          {
            path: 'lost-password',
            name: '/(user)/my-account/lost-password',
            component: () => import('/app/src/pages/(user)/my-account/lost-password.vue'),
            /* no children */
          },
          {
            path: 'orders',
            name: '/(user)/my-account/orders',
            component: () => import('/app/src/pages/(user)/my-account/orders.vue'),
            /* no children */
          },
          {
            path: 'register',
            name: '/(user)/my-account/register',
            component: () => import('/app/src/pages/(user)/my-account/register.vue'),
            /* no children */
          },
          {
            path: 'view-order',
            /* internal name: '/(user)/my-account/view-order' */
            /* no component */
            children: [
              {
                path: ':id',
                name: '/(user)/my-account/view-order/[id]',
                component: () => import('/app/src/pages/(user)/my-account/view-order/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/app/src/pages/[...path].vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

